import { Routes } from '@angular/router';
import { MeetComponent } from './meet.component';
import { MeetDashboardComponent } from './meet-dashboard/meet-dashboard.component';
import { SidebarHomeComponent } from './sidebar-home/sidebar-home.component';

export default [
  {
    path: ':meetId',
    component: MeetComponent,
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            component: MeetDashboardComponent,
          },
          {
            path: '',
            component: SidebarHomeComponent,
            outlet: 'secondSidebar',
          },
        ],
      },
      {
        path: 'checking-in-now',
        children: [
          {
            path: '',
            loadComponent: () => import('./check-in/check-in.component').then((c) => c.CheckInComponent),
          },
          {
            path: '',
            loadComponent: () =>
              import('./check-in-sidebar/check-in-sidebar.component').then((c) => c.CheckInSidebarComponent),
            outlet: 'secondSidebar',
          },
        ],
      },
      { path: 'athletes', loadChildren: () => import('../athlete/routes') },
      { path: 'events', loadChildren: () => import('../event/routes') },
      { path: 'media', loadChildren: () => import('../media/routes') },
      { path: 'live', loadChildren: () => import('../live/routes') },
      { path: 'track-scores', loadChildren: () => import('../track-scores/routes') },
      { path: 'reports', loadChildren: () => import('../reports/routes') },
      { path: 'follow', loadChildren: () => import('../follow/routes') },
      // {
      //   path: 'events',
      //   component: EventSidebarComponent,
      //   outlet: 'secondSidebar',
      //   // children: [
      //   //   {
      //   //     path: 'filter',
      //   //     component: EventSidebarFilterComponent,
      //   //     data: {animation: 'EventSidebarFilterComponent'}
      //   //   },
      //   //   {
      //   //     path: 'list',
      //   //     component: EventSidebarListComponent,
      //   //     data: {animation: 'EventSidebarListComponent'}
      //   //   },
      //   // ]
      // },
      { path: 'teams', loadChildren: () => import('../team/routes') },
    ],
  },
] as Routes;
